import React from "react";

/**
 * Primary button component with customizable styling
 */
const PrimaryButton = ({
  onClick,
  children,
  variant = "primary", // primary, danger, secondary
  style = {},
  width = "100%",
  height = "40px",
  disabled = false,
}) => {
  const variantStyles = {
    primary: {
      backgroundColor: "white",
      border: "2px solid #0056b3",
      color: "#0056b3",
    },
    danger: {
      backgroundColor: "white",
      border: "2px solid red",
      color: "red",
    },
    secondary: {
      backgroundColor: "white",
      border: "2px solid gray",
      color: "gray",
    },
  };

  const baseStyle = {
    width,
    height,
    borderRadius: "5px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: disabled ? "not-allowed" : "pointer",
    opacity: disabled ? 0.5 : 1,
    ...variantStyles[variant],
    ...style,
  };

  return (
    <button style={baseStyle} onClick={onClick} disabled={disabled}>
      {children}
    </button>
  );
};

export default PrimaryButton;
